import React from "react";
import { observer } from "mobx-react";
import { action } from "mobx";
import TrainingComponentEditor, { FormGroup } from "./TrainingComponentEditor";

@observer
class PracticeRecordReview extends TrainingComponentEditor {
  initializeData() {
    return { text: "", reviewTitle: "" };
  }

  @action.bound
  handleTextChange(event) {
    this.data.text = event.target.value;
  }

  @action.bound
  handleReviewTitleChange(event) {
    this.data.reviewTitle = event.target.value;
  }

  render() {
    return (
      <div>
        <FormGroup
          name="prompt"
          label="Prompt to appear when recording the video"
        >
          {(formControl) => (
            <textarea
              {...formControl}
              onChange={this.handleTextChange}
              value={this.data.text}
            />
          )}
        </FormGroup>
        <FormGroup
          name="reviewTitle"
          label="Prompt to appear when reviewing the video"
        >
          {(formControl) => (
            <input
              {...formControl}
              onChange={this.handleReviewTitleChange}
              value={this.data.reviewTitle}
            />
          )}
        </FormGroup>
      </div>
    );
  }
}

export default PracticeRecordReview;
